const DOMAIN = 'dev.my.calenso.com';
const BASE_URL = 'https://' + DOMAIN;

export const environment = {
  apiUrl: BASE_URL + '/api/v1/',
  appointmentConfirmationPageUrl: 'https://calio.calenso.com/appointments/',
  avatarImagePath: BASE_URL + '/files/workers/avatar/',
  backgroundImagePath: BASE_URL + '/files/partners/booking_page_background_logo/',
  baseUrl: BASE_URL,
  dashboardUrl: 'https://calio.calenso.com',
  defaultBookingPartnerName: 'calenso',
  deployUrl: 'https://dev.book.calenso.com',
  encryptedKey: 'FtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ',
  eventImagePath: BASE_URL + '/files/events/image/',
  brandName: 'Calenso',
  companyName: 'Calenso AG',
  brandFolder: 'calenso',
  widgetTag: 'calenso-booking',
  foundingYear: 2016,
  eventImgFallback: 'default-logo.svg',
  faviconImagePath: BASE_URL + '/files/partners/favicon_logo/',
  landingPageImagePath: BASE_URL + '/files/partners/landingpage_logo/',
  partnersImagePath: BASE_URL + '/files/partners/logo/',
  storeImagePath: BASE_URL + '/files/stores/logo/',
  production: false,
  version: '9.3.0',
  sentryDsn: 'https://143353e4fa83b1f043ad39ae84253864@o4506308503273472.ingest.sentry.io/4506467193978880',
  webcomponentWidgetUrl: 'https://dev.webcomponent.calenso.com',
  defaultLocale: 'de_CH',
};
